import React from 'react';
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Header, Modal, Grid, Checkbox, Divider } from 'semantic-ui-react';
import diamond from '../../../../../images/grafix-icon/diamond.svg'
import TextEditor from './../../../../common/TextEditor'
import { durationValidation } from '../../../../common/RegexValidation';
let Milestone = false;
class AddPhasesModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            MakeAnotherActivity: false,
            name: '',
            description: ''
        }

        this.onSubmitActivity = this.onSubmitActivity.bind(this);
        this.setMilestone = this.setMilestone.bind(this);
        this.setMakeAnotherActivity = this.setMakeAnotherActivity.bind(this);
        this.updateText = this.updateText.bind(this)
    }

    handleClose = () => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        dispatch.lifeCycle.showResourecePane(null);
        dispatch.createPack.PhaseModalOpen(false);
        Milestone = false;
        this.setState({
            MakeAnotherActivity: false,
            name: '',
            description: ''
        });
    }

    async onSubmitActivity(formData) {
        await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        dispatch.lifeCycle.showResourecePane(null);
        let nodeToAdd = {
            name: this.state.name,
            description: this.state.description,
            packId: this.props.selectedPracticeLibrary._id,
            branchID: this.props.tree.branchID,
            lastUpdatedBy: this.props.user,
            parentActivity: this.props.tree._id,
            isLeafNode: true,
            duration: formData.duration ? formData.duration : 1,
            isMilestone: Milestone,
            accountId: this.props.selectedPracticeLibrary.accountId,
            organizationId: this.props.selectedPracticeLibrary.organizationId
        }
        await dispatch.lifeCycle.createActivity(nodeToAdd);
        this.setState({ 'description': '', 'name': '' })
        if (!this.state.MakeAnotherActivity) {
            dispatch.createPack.PhaseModalOpen(false);
        }
        else {
            // document.getElementById("AddphaseActivityForm").reset();
            this.refs.form.reset();
            const nameElem = document.getElementById("Name");
            if (nameElem) {
                nameElem.focus();
            }
        }
        Milestone = false;
    }

    setMilestone(data) {
        Milestone = !Milestone;
        this.forceUpdate();
    }
    setMakeAnotherActivity(event, data) {
        this.setState({ MakeAnotherActivity: data.checked });
    }

    updateText(data, name) {
        if (name === "Name") {
            this.setState({ name: data })
        } else if (name === "Description") {
            this.setState({ description: data })
        } else if (name === "Duration") {
            this.setState({ duration: data })
        }
    }

    render() {
        const errorLabel = <div className="customErrorLabel margin_bottom_10" />;
        const inlineStyle = {
            modal: {
                marginTop: '0px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        return (
            <Modal
                style={inlineStyle.modal}
                open={this.props.isPhaseAddFlag}
                onClose={this.handleClose}
                size='tiny'
                closeOnEscape={true}
                className="basicModal"
                closeOnDimmerClick={false}
                closeIcon
            >
                <Header content={"Add new activity under " + this.props.tree.name} />
                <Divider />
                <Form noValidate
                    ref="form"
                    id="AddphaseActivityForm"
                    onValidSubmit={(event) => { this.onSubmitActivity(event) }}
                >
                    <Modal.Content>
                        <Grid>
                            <Grid.Row >
                                <Grid.Column width={16}>
                                    <TextEditor
                                        name="Name"
                                        text={this.state.name}
                                        type="text"
                                        onChangeText={this.updateText}
                                        autoFocus
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <TextEditor
                                        name="Description"
                                        text={this.state.description}
                                        type="textarea"
                                        onChangeText={this.updateText}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row className="pad_0">
                                <Grid.Column width={8}>

                                    <Form.Input
                                        name="duration"
                                        label="Duration (In Days)"
                                        id="duration"
                                        validations={{ matchRegexp: durationValidation }}
                                        // validations={{ matchRegexp: *******,
                                        validationErrors={{
                                            matchRegexp: 'Enter valid duration upto 3 digit.',
                                        }}
                                        errorLabel={errorLabel}
                                        instantValidation
                                    />
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <div style={{ textAlign: 'right' }}><br />
                                        <img src={diamond} name="diamond" style={{ 'height': '12px' }} alt='' />&nbsp;
                                        <span>Milestone Activity</span>
                                        <Checkbox className='diamond-location' checked={Milestone} onChange={this.setMilestone} />
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                    </Modal.Content>
                    <Divider />
                    <Modal.Actions className="actionInFormcy">
                        <div className="float-left" style={{ textAlign: 'left' }}>
                            <span>Create Another Activity</span>
                            <Checkbox className='diamond-location' checked={this.state.MakeAnotherActivity}
                                onChange={(event, data) => this.setMakeAnotherActivity(event, data)} />
                        </div>

                        <Button
                            className="button-submit float-right"
                            id='addbtn'
                            type="submit"> Add</Button>
                        <Button
                            id='cancelBtn'
                            onClick={this.handleClose}
                            type="button"
                            className="button-cancel"> Cancel </Button>
                    </Modal.Actions>
                </Form>
            </Modal>
        )
    }
}

export default AddPhasesModal